export default [
  {
    path: '/activity/priceTag',
    name: 'priceTag',
    meta: {
      title: '价格标签'
    },
    component(resolve) {
      require(['COMPONENTS/activity/priceTag/main.vue'], resolve)
    }
  },
  {
    path: '/activity/priceTagEdit',
    name: 'priceTagEdit',
    meta: {
      title: '价格标签编辑'
    },
    component(resolve) {
      require(['COMPONENTS/activity/priceTag/priceTagEdit.vue'], resolve)
    }
  },
  {
    path: '/activity/showTimeLimitPrice',
    name: 'showTimeLimitPrice',
    meta: {
      title: '限时改价'
    },
    component(resolve) {
      require(['COMPONENTS/activity/showTimeLimitPrice/main.vue'], resolve)
    }
  },
  {
    path: '/activity/specialAdvertisement',
    name: 'specialAdvertisement',
    meta: {
      title: '活动特殊广告'
    },
    component(resolve) {
      require(['COMPONENTS/activity/specialAdvertisement/main.vue'], resolve)
    }
  },
  {
    path: '/activity/specialAdvertisementEdit',
    name: 'specialAdvertisementEdit',
    meta: {
      title: '活动特殊广告'
    },
    component(resolve) {
      require(['COMPONENTS/activity/specialAdvertisement/edit.vue'], resolve)
    }
  },
  {
    path: '/activity/addCartPrize',
    name: 'addCartPrize',
    meta: {
      title: '加购物车得奖'
    },
    component(resolve) {
      require(['COMPONENTS/activity/addCartPrize/main.vue'], resolve)
    }
  },
  {
    path: '/activity/addCartPrizeEdit',
    name: 'addCartPrizeEdit',
    meta: {
      title: '加购物车得奖编辑'
    },
    component(resolve) {
      require(['COMPONENTS/activity/addCartPrize/edit.vue'], resolve)
    }
  },
  {
    path: '/activity/addCartPrizeConfig',
    name: 'addCartPrizeConfig',
    meta: {
      title: '奖品配置'
    },
    component(resolve) {
      require(['COMPONENTS/activity/addCartPrize/prizeConfig/main.vue'], resolve)
    }
  },
  {
    path: '/activity/addCartPrizeConfigEdit',
    name: 'addCartPrizeConfigEdit',
    meta: {
      title: '奖品配置编辑'
    },
    component(resolve) {
      require(['COMPONENTS/activity/addCartPrize/prizeConfig/edit.vue'], resolve)
    }
  },
  {
    path: '/activity/addCartRuleConfig',
    name: 'addCartRuleConfig',
    meta: {
      title: '规则配置'
    },
    component(resolve) {
      require(['COMPONENTS/activity/addCartPrize/ruleConfig/main.vue'], resolve)
    }
  },
  {
    path: '/activity/addCartRuleConfigEdit',
    name: 'addCartRuleConfigEdit',
    meta: {
      title: '规则配置编辑'
    },
    component(resolve) {
      require(['COMPONENTS/activity/addCartPrize/ruleConfig/edit.vue'], resolve)
    }
  },
  {
    path: '/activity/addCartPrizeRecord',
    name: 'addCartPrizeRecord',
    meta: {
      title: '中奖记录'
    },
    component(resolve) {
      require(['COMPONENTS/activity/addCartPrize/prizeRecord/main.vue'], resolve)
    }
  },
  {
    path: '/activity/collectionList',
    name: 'collectionList',
    meta: {
      title: '小程序单品合集页',
    },
    component(resolve) {
      require(['COMPONENTS/activity/collectionList/main.vue'], resolve)
    }
  },
  {
    path: '/activity/zys',
    name: 'zys',
    meta: {
      title: '张一山分享活动',
    },
    component(resolve) {
      require(['COMPONENTS/activity/zys/main.vue'], resolve)
    }
  },
  {
    path: '/activity/definitionSummer',
    name: 'definitionSummer',
    meta: {
      title: 'ICY定义你的夏天',
    },
    component(resolve) {
      require(['COMPONENTS/activity/definitionSummer/main.vue'], resolve)
    }
  },
  {
    path: '/activity/couponsPop',
    name: 'couponsPop',
    meta: {
      title: '小程序优惠券弹窗',
    },
    component(resolve) {
      require(['COMPONENTS/activity/couponsPop/main.vue'], resolve)
    }
  }, {
    path: '/activity/editCouponsPop',
    name: 'editCouponsPop',
    meta: {
      title: '优惠券弹窗配置',
    },
    component(resolve) {
      require(['COMPONENTS/activity/couponsPop/editCouponsPop.vue'], resolve)
    }
  },
  {
    path: '/activity/miniAppAdv',
    name: 'miniAppAdv',
    meta: {
      title: '小程序广告设置',
    },
    component(resolve) {
      require(['COMPONENTS/activity/miniAppAdv/main.vue'], resolve)
    }
  },
  {
    path: '/activity/editMiniAppAdv',
    name: 'editMiniAppAdv',
    meta: {
      title: '小程序广告设置',
    },
    component(resolve) {
      require(['COMPONENTS/activity/miniAppAdv/editMiniAppAdv.vue'], resolve)
    }
  },
  {
	path: '/activity/miniGoodsQrcode',
	name: 'miniGoodsQrcode',
	meta: {
	  title: '小程序码下载',
	},
	component(resolve) {
	  require(['COMPONENTS/activity/miniGoodsQrcode/main.vue'], resolve)
	}
  },
]